import React from "react";
import {PermissionGuard} from "../../components/PermissionGuard";
import {BsrsManagementFeature} from "../../features/bsrsManagement";
import {StandardLayout} from "../../components/StandardLayout";

const ALLOWED_PERMISSION = 'bsrs';

const BsrsManagementPage = ({
  userToken,
  userPermissions,
}) => (
  <PermissionGuard
    userToken={userToken}
    userPermissions={userPermissions}
    permissionKey={ALLOWED_PERMISSION}
  >
    <StandardLayout
      headerTitle="BSRS系統"
      body={
        <BsrsManagementFeature userToken={userToken} />
    }/>
  </PermissionGuard>
)

export default BsrsManagementPage